/*
    ./client/components/App.jsx
*/
import React from "react";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import { Menu, Popup } from "semantic-ui-react";
import MetPanel from "./metPanel";
import {ReactComponent as MetIcon} from '../../../images/Meteorology.svg';

/**
 * Button to control whether the met displaying/editing views are visible
 */
class MetMenu extends React.Component {
  getContent = () => {
    if (this.props.activeItem === this.props.name) {
      return <MetPanel cancel={this.props.cancel} next={this.props.next} />;
    }
    return null;
  };

  render() {
    return (
      <>
        <Popup
          className="popup"
          mouseEnterDelay={300}
          trigger={
            <Menu.Item
              className="icon-container"
              name={this.props.name}
              active={this.props.activeItem === this.props.name}
              onClick={this.props.onClick}
            >
              <MetIcon className="sidebar-icon" />
            </Menu.Item>
          }
          position={"right center"}
        >
          {this.props.title}
        </Popup>

        <div className="menu-option">{this.getContent()}</div>
      </>
    );
  }
}

export default compose(withTranslation())(MetMenu);
